import Images from 'src/common/Images'

export const ROUTER_PATH = {
   // Admin
   // DashboardScreen: 'admin/dashboard',
   AccountScreen: 'admin/account',
   AccountCreateScreen: 'admin/account/create',
   AccountDetailScreen: 'admin/account/detail/:id',
   AccountUpdateScreen: 'admin/account/:id',

   TripScreen: 'admin/trip',
   TripCreateScreen: 'admin/trip/create',
   TripDetailScreen: 'admin/trip/detail/:id',
   TripUpdateScreen: 'admin/trip/:id',

   PriceScreen: 'admin/price',
   PriceCreateScreen: 'admin/price/create',
   PriceDetailScreen: 'admin/price/detail/:id',
   PriceUpdateScreen: 'admin/price/:id',

   PromotionScreen: 'admin/promotion',
   PromotionCreateScreen: 'admin/promotion/create',
   PromotionDetailScreen: 'admin/promotion/detail/:id',
   PromotionUpdateScreen: 'admin/promotion/:id',

   ProvinceScreen: 'admin/province',
   ProvinceCreateScreen: 'admin/province/create',
   ProvinceDetailScreen: 'admin/province/detail/:id',
   ProvinceUpdateScreen: 'admin/province/:id',

   LocationScreen: 'admin/location',
   LocationCreateScreen: 'admin/location/create',
   LocationDetailScreen: 'admin/location/detail/:id',
   LocationUpdateScreen: 'admin/location/:id',

   NotificationScreen: 'admin/notification',
   NotificationCreateScreen: 'admin/notification/create',
   NotificationDetailScreen: 'admin/notification/detail/:id',
   NotificationUpdateScreen: 'admin/notification/:id',

   FundScreen: 'admin/fund',
   FundCreateScreen: 'admin/fund/create',
   FundDetailScreen: 'admin/fund/detail/:id',
   FundUpdateScreen: 'admin/fund/:id',
   CommonConfigScreen: 'admin/common-config',

   // User
   ProfileScreen: 'profiles',
   ResetPassword: 'reset-password'

   // Accountant
}

export const adminMeta = [
   {
      id: 0,
      label: 'Quản trị',
      labelKey: 'admin', // Quản trị
      path: '/admin',
      items: [
         // {
         //    label: 'Dashboard',
         //    labelKey: 'Dashboard', //Dashboard
         //    icon: Images.ic_config_product_type,
         //    path: `/${ROUTER_PATH.DashboardScreen}`
         // },
         {
            label: 'Quản lý Tài khoản',
            labelKey: 'account_management',
            icon: Images.ic_manage_sim,
            path: `/${ROUTER_PATH.AccountScreen}`
         },
         {
            label: 'Quản lý chuyến đi',
            labelKey: 'trip_management',
            icon: Images.ic_config_product_type,
            path: `/${ROUTER_PATH.TripScreen}`
         },

         {
            label: 'Quản lý Tỉnh/Thành phố',
            labelKey: 'province_management',
            icon: Images.ic_history_sync,
            path: `/${ROUTER_PATH.ProvinceScreen}`
         },
         {
            label: 'Quản lý địa điểm',
            labelKey: 'location_management',
            icon: Images.ic_history_sync,
            path: `/${ROUTER_PATH.LocationScreen}`
         },
         {
            label: 'Quản lý giá',
            labelKey: 'price_management',
            icon: Images.ic_history_sync,
            path: `/${ROUTER_PATH.PriceScreen}`
         },
         {
            label: 'Quản lý quỹ',
            labelKey: 'fund_management',
            icon: Images.ic_manage_sales_channel,
            path: `/${ROUTER_PATH.FundScreen}`
         },
         {
            label: 'Cấu hình chung',
            labelKey: 'common_config',
            icon: Images.ic_manage_value_added_services,
            path: `/${ROUTER_PATH.CommonConfigScreen}`
         },
         {
            label: 'Khuyến mại',
            labelKey: 'promotion',
            icon: Images.ic_product_category,
            path: `/${ROUTER_PATH.PromotionScreen}`
         },
         {
            label: 'Thông báo',
            labelKey: 'notification',
            icon: Images.ic_manage_sim,
            path: `/${ROUTER_PATH.NotificationScreen}`
         }
      ]
   }
   // {
   //    id: 1,
   //    label: 'Quản lý sản phẩm',
   //    labelKey: 'product_management', // Quản lý sản phẩm
   //    path: '/products/packages',
   //    items: [
   //       {
   //          label: 'Quản lý gói cước',
   //          labelKey: 'package_management', // Quản lý gói cước
   //          icon: Images.ic_manage_packages,
   //          path: '/products/packages',
   //          items: [
   //             {
   //                label: 'Data',
   //                labelKey: 'data', // Data
   //                icon: Images.ic_dot,
   //                path: `/${ROUTER_PATH.PackagesProducts3g4gScreen}`
   //             },
   //             {
   //                label: 'Add on',
   //                labelKey: 'add_on', // Add on
   //                icon: Images.ic_dot,
   //                path: `/${ROUTER_PATH.PackagesProductsAddonScreen}`
   //             },
   //             {
   //                label: 'Special',
   //                labelKey: 'special', // Special
   //                icon: Images.ic_dot,
   //                path: `/${ROUTER_PATH.PackagesProductsSpecialScreen}`
   //             }
   //          ]
   //       },
   //    ]
   // }
   // {
   //    id: 2,
   //    label: 'Danh mục',
   //    labelKey: 'categories', // Danh mục
   //    path: '/categories',
   //    items: [
   //       {
   //          label: 'Quản lý nhóm sản phẩm',
   //          labelKey: 'product_group_management', // Danh mục sản phẩm
   //          icon: Images.ic_product_category,
   //          path: `/${ROUTER_PATH.ProductsCategoryScreen}`
   //       }
   //    ]
   // }
]
export const saleMeta = [
   {
      id: 0,
      label: 'Quản trị',
      labelKey: 'admin', // Quản trị
      path: '/admin',
      items: [
         // {
         //    label: 'Dashboard',
         //    labelKey: 'Dashboard', //Dashboard
         //    icon: Images.ic_config_product_type,
         //    path: `/${ROUTER_PATH.DashboardScreen}`
         // },
         {
            label: 'Quản lý Tài khoản',
            labelKey: 'account_management',
            icon: Images.ic_manage_sim,
            path: `/${ROUTER_PATH.AccountScreen}`
         },
         {
            label: 'Quản lý chuyến đi',
            labelKey: 'trip_management',
            icon: Images.ic_config_product_type,
            path: `/${ROUTER_PATH.TripScreen}`
         }

         // {
         //    label: 'Quản lý Tỉnh/Thành phố',
         //    labelKey: 'province_management',
         //    icon: Images.ic_history_sync,
         //    path: `/${ROUTER_PATH.ProvinceScreen}`
         // },
         // {
         //    label: 'Quản lý địa điểm',
         //    labelKey: 'location_management',
         //    icon: Images.ic_history_sync,
         //    path: `/${ROUTER_PATH.LocationScreen}`
         // },
         // {
         //    label: 'Quản lý giá',
         //    labelKey: 'price_management',
         //    icon: Images.ic_history_sync,
         //    path: `/${ROUTER_PATH.PriceScreen}`
         // },
         // {
         //    label: 'Quản lý quỹ',
         //    labelKey: 'fund_management',
         //    icon: Images.ic_manage_sales_channel,
         //    path: `/${ROUTER_PATH.FundScreen}`
         // },
         // {
         //    label: 'Cấu hình chung',
         //    labelKey: 'common_config',
         //    icon: Images.ic_manage_value_added_services,
         //    path: `/${ROUTER_PATH.CommonConfigScreen}`
         // },
         // {
         //    label: 'Khuyến mại',
         //    labelKey: 'promotion',
         //    icon: Images.ic_product_category,
         //    path: `/${ROUTER_PATH.PromotionScreen}`
         // }
      ]
   }
]
// Danh sách các đường dẫn chính cần active
export const mainRoutes = adminMeta.flatMap((group) => group.items.map((item) => item.path))

export const userMeta = [
   {
      label: 'AccountScreen',
      labelKey: 'AccountScreen', //Dashboard
      icon: Images.ic_config_product_type,
      path: `/${ROUTER_PATH.AccountScreen}`
   }
]
